"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _TextField = _interopRequireDefault(require("@mui/material/TextField"));

var _Typography = _interopRequireDefault(require("@mui/material/Typography"));

var _Paper = _interopRequireDefault(require("@mui/material/Paper"));

var _Button = _interopRequireDefault(require("@mui/material/Button"));

var _normalizePostalCode = _interopRequireDefault(require("@developers/utils/normalizePostalCode"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Zip = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Zip, _Component);

  var _super = _createSuper(Zip);

  function Zip(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Zip);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleChange", function (e) {
      var formatted = (0, _normalizePostalCode["default"])(e.target.value);

      _this.setState({
        zip: formatted
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleKeyPress", function (e) {
      if (e.key == 'Enter') {
        _this.props.handleUpdate(_this.state.zip);
      }
    });
    _this.state = {
      zip: ''
    };
    return _this;
  }

  (0, _createClass2["default"])(Zip, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      if (this.props.zip) {
        this.setState({
          zip: this.props.zip
        });
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.zip != this.props.zip) {
        this.setState({
          zip: nextProps.zip
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var zip = this.state.zip;
      var _this$props = this.props,
          handleUpdate = _this$props.handleUpdate,
          loading = _this$props.loading;
      return /*#__PURE__*/_react["default"].createElement(_Paper["default"], {
        style: {
          padding: '15px',
          marginBottom: '15px'
        }
      }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        variant: "body1"
      }, "Estimate Shipping (US/Canada only) - Enter ", /*#__PURE__*/_react["default"].createElement("b", null, "Postal Code:")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-md-7"
      }, /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
        id: "shipping-zip",
        placeholder: "Zip/Postal Code",
        variant: "standard",
        style: {
          width: '100%'
        },
        value: zip,
        onChange: this.handleChange,
        disabled: loading,
        onKeyPress: this.handleKeyPress
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-md-5",
        style: {
          display: zip ? 'block' : 'none'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          textAlign: 'right'
        }
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        variant: "contained",
        color: "primary",
        onClick: function onClick() {
          return handleUpdate(zip);
        },
        disabled: loading
      }, "Update")))));
    }
  }]);
  return Zip;
}(_react.Component);

exports["default"] = Zip;